import(/* webpackMode: "eager" */ "/workspace/app/authors/components/Search.jsx");
import(/* webpackMode: "eager" */ "/workspace/custom/CustomBreadcrumbs.jsx");
import(/* webpackMode: "eager" */ "/workspace/custom/CustomPagination.jsx");
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/link.js")